module.exports = __webpack_public_path__ + "static/media/mic-logo.85de6c6c.svg";